import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchAllActiveCompanies, fetchCompanies } from "../../db/Companies";
import { use } from "react";
import CompanyCard from "./CompanyCard";
import PageHeader from "../../components/controls/PageHeader";
import AnanasSolutionsLogo from "../../images/AnanasSolutionsLogo.webp";

export default function CompanyGallery() {
  const [companies, setCompanies] = useState([]);
  const activeCompanies = companies.filter((c) => c.isActive);
  const { t } = useTranslation();

  useEffect(() => {
    console.log("Loading companies...");
    const loadCompanies = async () => {
      try {
        const result = await fetchAllActiveCompanies();
        setCompanies(result);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des entreprises :",
          error
        );
      }
    };

    loadCompanies();
  }, []);

  return (
    <div className="p-0 overflow-x-hidden">
      {/* Header plein écran avec motif/logo */}
      <PageHeader
        title={t("partners.title")}
        subtitle={t("partners.description")}
        logoSrc={AnanasSolutionsLogo}
        align="center"
        fullBleed={true} // full width
        rounded={false} // bord à bord
        height="sm" // sm | md | lg
        gradient={{ from: "#E9FBFA", via: "#FFF9E6", to: "#FFE9EC" }}
        patternSize="32px 32px"
        patternOpacity={15}
      />

      {/* Contenu de la page */}
      <div className="px-4 pb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {activeCompanies.map((company) => (
            <CompanyCard key={company.id} company={company} />
          ))}
        </div>
      </div>
    </div>
  );
}
